import { STATUS_ICON_LOADING } from '@/common/utils/statuses';
import createCommonModule from '@/common/store/modules/common';
import iscsiUpdater from '@/common/store/modules/iscsi/iscsiUpdater';
import { TaskState } from '@schema';
import { TaskName } from '@/common/constants/taskNames.constants';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

export default createCommonModule({
  resource() {
    return getClusterId()
      .then(clusterId => `/api/v2/${clusterId}/iscsi-alua/users`);
  },
  plural: data => data.map(user => ({ ...user, id: user.name })),
  Model: Object,
  config: {
    updateMethod: 'put',
    needWaitTask: true
  },
  socketUpdates: true,
  getters: {
    _mapItem: (state, getters, rootState, rootGetters) => (userId) => {
      const item = state.itemsMap[userId];
      if (!item) {
        return null;
      }
      const targetGroups = rootGetters['iscsi/targetGroups/getItems']
        .filter(tg => tg.chap_user === item.name) || [];
      return {
        ...item,
        id: item.name,
        isDeletable: !!item.name && targetGroups.length === 0,
        statusIcon: (item.tasks && item.tasks.length) ? STATUS_ICON_LOADING : false,
        targetGroups,
        targetGroupsCount: targetGroups.length
      };
    },
  },
  actions: {
    DELETE_ITEMS({ dispatch }, items) {
      return dispatch('DELETE_ITEMS_STEP_BY_STEP', items);
    },
    socket_iscsi({ dispatch }, message) {
      if (message.type === 'user') {
        const id = message?.object?.username;
        dispatch('UPDATE_ITEM', id, message.operation);
      }
    },
    socket_tasks({ dispatch }, { name, state }) {
      const TASK_EVENT_NAMES = [
        TaskName.BLOCK_STORAGE_USER_CREATE,
        TaskName.BLOCK_STORAGE_USER_CHANGE,
        TaskName.BLOCK_STORAGE_USER_DELETE,
      ];
      if (TASK_EVENT_NAMES.includes(name) && state === TaskState.SUCCESS) {
        dispatch('FETCH_ITEMS');
      }
    },
    ...iscsiUpdater('users')
  }
});
